import type { UserAuth } from '~/schemas/auth'

export default defineNuxtPlugin(() => {
  const { user, isAuthenticated } = useSanctumAuth<UserAuth>()
  const notificationsStore = useNotificationsStore()

  watch(
    [user, isAuthenticated],
    ([newUser, isLoggedIn]) => {
      if (isLoggedIn && newUser) {
        notificationsStore.startPolling()
      } else {
        notificationsStore.stopPolling()
      }
    },
    { immediate: true }
  )
})
